import React from 'react'
import Logo from "../../assets/svg/logo.svg"
import footerMap from "../../assets/images/footer-map.png"
import { Link, useTranslation } from "../../plugins/i18next/ea-react-i18next";

const Footer = () => {
    const { t } = useTranslation("components", { keyPrefix: 'app.footer' });
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-area bg-color d-print-none">
            <div className="container-fluid hero-container">
                <div className="row">
                    <div className="col-lg-4 col-sm-6">
                        <div className="single-footer-widget">
                            <a href="/" className="logo">
                                <img src={Logo} alt="logo" />
                            </a>
                            <p>{t("marketingMessage")}</p>
                            <ul className="social-link">
                                <li>
                                    <a href="https://www.x.com/easylife_365" className="d-block" target="_blank" rel="noreferrer">
                                        <svg width="16" height="16" viewBox="-218.42 -204.68 1636.36 1636.36" xmlns="http://www.w3.org/2000/svg"><path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="currentColor" /></svg>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/easylife365/" className="d-block" target="_blank" rel="noreferrer">
                                        <i className='bx bxl-linkedin'></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/easylife365ag/" className="d-block" target="_blank" rel="noreferrer">
                                        <i className='bx bxl-instagram'></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-2 col-sm-6">
                        <div className="single-footer-widget pl-2">
                            <h3>{t('title')}</h3>

                            <ul className="footer-links-list">
                                <li>
                                    <Link to="/blog">
                                        {t('ourBlog')}
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/aboutus">
                                        {t('aboutus')}
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/elatw">
                                        {t('elatw')}
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/products/collaboration">
                                        {t('collabapp')}
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/products/identity">
                                        {t('identityapp')}
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/products/mail">
                                        {t('mailapp')}
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/products/meet">
                                        {t('meetapp')}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-2 col-sm-6">
                        <div className="single-footer-widget">
                            <h3>  {t('contact.resources')}</h3>

                            <ul className="footer-links-list">
                                <li>
                                    <a href="https://docs.easylife365.cloud/" target="_blank">
                                        {t('documentation')}
                                    </a>
                                </li>
                                <li>
                                    <Link to="/partners/our-partners">
                                        {t('ourPartners')}
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/partners/become-a-partner">
                                        {t('becomePartner')}
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/pricing">
                                        {t('pricingCalculator')}
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/support">
                                        {t('support')}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6">
                        <div className="single-footer-widget">
                            <h3>{t('contact.title')}</h3>
                            <ul className="footer-contact-info">
                                <li>
                                    <i className='bx bx-map'></i>
                                    Schochenmühlestrasse 6, 6340 Baar <br /> Switzerland
                                </li>
                                <li>
                                    <i className='bx bx-phone-call'></i>
                                    <a href="tel:+41 41 210 29 69">+41 41 210 29 69</a>
                                </li>
                                <li>
                                    <i className='bx bx-envelope'></i>
                                    <a href="mailto:unicorn@easylife365.cloud">unicorn@easylife365.cloud</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom-area">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <p>Copyright @{currentYear} <strong>EasyLife 365</strong> All rights reserved</p>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <ul>
                                <li>
                                    <Link to="/legal/web/privacy">
                                        {t('privacy')}
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/legal/terms">
                                        {t('terms')}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-map">
                <img src={footerMap} alt="footer-logo" />
            </div>
        </footer>
    );
}

export default Footer;